import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NotificationBarComponent } from '../notification-bar/notification-bar.component';
import { AnnouncementBannerService } from '../../services/announcement-banner/announcement-banner.service';

@Component({
  selector: 'maintenance-banner',
  imports: [NotificationBarComponent],
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceBannerComponent implements OnInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);
  private readonly ngZone = inject(NgZone);
  protected readonly announcementBannerService = inject(AnnouncementBannerService);
  private resizeObserver?: ResizeObserver;

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver((entries) => {
        this.announcementBannerService.setHeight(entries[0].contentRect.height);
      });
      this.resizeObserver.observe(this.elementRef.nativeElement);
    });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.announcementBannerService.setHeight(0);
  }

  protected handleCloseNoti(): void {
    this.announcementBannerService.dismiss();
  }
}
